// extracted by mini-css-extract-plugin
export default {"bodyMinHeight":"_b538845f"};